import { render, staticRenderFns } from "./ConsumersEmailPromotion.vue?vue&type=template&id=3e6571d3"
import script from "./ConsumersEmailPromotion.vue?vue&type=script&lang=js"
export * from "./ConsumersEmailPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports